<mat-toolbar>
   <span>SEN-SEI Technologies</span>
   <span class="example-spacer"></span>
   <a class="" href="sen-sei.in" _target="_blank" class="menu-top">
       Powered by
    <img src="assets/images/logos-indus/encore-360-transparent-h60.png" alt="SEN-SEI" />
  </a>
 </mat-toolbar>